import { Artifact } from './artifactsTypes';

export type EventUser = {
  id: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  email: string;
  role: string;
};

export type DynamicFieldType = {
  id: string;
  title: string;
  field_key: string;
  field_type: string;
  required?: boolean;
  content?: string;
  max_length?: number;
  min_length?: number;
  instruction_text?: string;
  sort_order?: number;
  children?: {
    id: string;
    name: string;
  }[];
  sort_options?: boolean;
};

export type Detail = DynamicFieldType & {
  row_id: number;
};

export enum ParentTagName {
  STAGE_OF_VENTURE = 'Stage of Venture',
  TECHNOLOGY_TYPE = 'Technology Type',
}

export type MatchingCategory = {
  parent: {
    name: string;
    id: string;
  };
  name: string;
  id: string;
  enabled?: boolean;
};

export type Event = {
  id: string;
  name: string;
  description: string;
  slug: string;
  team_description: Detail | null;
  reply_to_name: string;
  reply_to_email: string;
  created_at: string;
  updated_at: string;
  gtmId: string | null;
  profile_enabled: boolean;
  signup_enabled: boolean;
  active: boolean;
  logo_url: string | null;
  qualitative_methodology: null;
  judging_ux_mode: 'quantitative_mode' | 'qualitative_only_mode';
  matching_categories: MatchingCategory[];
  inherited_matching_categories: MatchingCategory[];
  all_matching_categories: MatchingCategory[];
  judge_details: Detail[];
  team_details: Detail[];
  artifacts: Artifact[];
  categories?: DynamicFieldType[];
  start_date?: string;
  end_date?: string;
  team_signup_open?: string;
  team_signup_deadline?: string;
  team_signup_will_open?: boolean;
  team_profile_deletion_reasons?: {
    value: string;
    label: string;
  }[];
  award_date?: string;
  aggregate_amount?: number;
  number?: string;
  artifact_types?: {
    value: string;
    label: string;
  }[];
  artifact_file_types?: {
    value: string;
    label: string;
  }[];
};
